module.exports = __webpack_public_path__ + "media/32.3be07d1f.wav";